"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Input_1 = __importDefault(require("../Input"));

var AllCapsInput = function AllCapsInput(_a) {
  var language = _a.language,
      props = __rest(_a, ["language"]);

  return (0, jsx_runtime_1.jsx)(Input_1.default, Object.assign({}, props, {
    language: language,
    onChange: function onChange(event) {
      return props.onChange(Object.assign(Object.assign({}, event), {
        target: Object.assign(Object.assign({}, event.target), {
          value: event.target.value.toUpperCase()
        })
      }));
    }
  }));
};

AllCapsInput.displayName = "AllCapsInput";
exports.default = AllCapsInput;